class CustomSort extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.custom-sort__trigger');
    this.list = this.querySelector('.custom-sort__list');
    this.options = this.querySelectorAll('.custom-sort__option');
    this.current = this.querySelector('.custom-sort__current');
    this.select = this.querySelector('select[name="sort_by"]');
    this.onDocClick = this.onDocClick.bind(this);
  }

  connectedCallback() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });
    this.options.forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        this.choose(opt);
      });
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
  }

  toggle() {
    if (this.list.hidden) this.open();
    else this.close();
  }

  open() {
    this.list.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.classList.add('is-open');
    setTimeout(() => document.addEventListener('click', this.onDocClick), 0);
  }

  close() {
    this.list.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.classList.remove('is-open');
    document.removeEventListener('click', this.onDocClick);
  }

  onDocClick(e) {
    if (!this.contains(e.target)) this.close();
  }

  choose(opt) {
    const value = opt.dataset.value;
    const label = opt.textContent.trim();
    this.options.forEach((o) => {
      o.classList.toggle('is-selected', o === opt);
      o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
    });
    if (this.current) this.current.textContent = label;
    if (this.select) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.close();
  }
}

customElements.define('custom-sort', CustomSort);
